
import Big from 'big.js';
import * as types from 'generated/graphql';
import _ from 'lodash';
import { DateTime } from 'luxon';
import { ITypeSpecificPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/shared';


export const StandardTemplateMilestone: ITypeSpecificPolicy<types.StandardTemplateMilestone> = {
  fields: {
    durationFromProjectStartDateInMills: {
      read: (existing, {}) => {

        return _.toNumber(existing);
      }
    },
    estimatedStartDate: {
      read: (existing, { readField }) => {

        const durationFromStart = readField('durationFromTodayInMills');


        if (_.isNumber(durationFromStart)) {
          const now = DateTime.now().plus({
            milliseconds: Big(durationFromStart).toNumber()
          });

          return now.toISODate();
        }

      }
    }
  }
};
